import { getCurrentInstance } from 'vue';
import type Vue from 'vue';

export function useVm(): Vue {
  const instance = getCurrentInstance();
  if (!instance) {
    throw new Error('Vue composition helpers must be called inside setup()');
  }
  return instance.proxy as Vue;
}
